// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Form styling shared by the profile forms (profile data, change password): outlined rounded
 * inputs, title/description rows, primary and secondary buttons. Use it with
 * @include auth.auth-form; at the END of the component stylesheet, so it wins over older rules. */
ion-checkbox {
  margin-left: 0;
}

ion-button {
  width: 100%;
}

.iconTab {
  height: 15px;
  font-size: 16px;
}

.centerCol {
  display: flex;
  align-items: center;
}

ion-item.item-has-focus ion-label {
  color: var(--ion-color-secondary);
}
ion-item ion-input {
  border-bottom: thin solid rgba(var(--ion-color-medium-rgb), 0.25);
  --padding-end: 33px;
}
ion-item ion-input.ion-valid.has-focus {
  border-bottom-color: var(--ion-color-primary);
  border-bottom-width: 2px;
}

ion-checkbox {
  margin-right: 15px;
}

.label-term-of-condition {
  white-space: pre-wrap;
}

.item-remember-me {
  margin-top: 9px;
}

.item-auto-access {
  margin-bottom: 9px;
}

.checkbox-in-list,
.checkbox-label {
  margin-top: 0;
  margin-bottom: 0;
}

.item-checkbox {
  --ripple-color: transparent;
  --background-hover: var(--background);
  --min-height: 35px;
}

.button-login {
  --box-shadow: none;
  --border-radius: 10px;
  font-size: 17px;
}

.button-account {
  --box-shadow: none;
  --background: white;
  color: var(--ion-color-primary);
  border: 1px solid var(--ion-color-primary) !important;
}

.divRole {
  background-color: var(--ion-color-primary);
  color: white;
  width: 100%;
  border-radius: 10px;
  cursor: hand;
  cursor: pointer;
  border: 2px solid var(--ion-color-primary);
}
.divRole ion-icon {
  color: white;
}

.divRoleNotSelected {
  background-color: white;
  border-radius: 10px;
  width: 100%;
  color: var(--ion-color-primary);
  border: 2px solid var(--ion-color-primary);
  cursor: hand;
  cursor: pointer;
}

.gridRole {
  padding: 15px 15px;
}

ion-icon {
  color: var(--ion-color-primary);
}

.roleItem {
  margin-top: 5px;
}

.labelRole {
  margin-left: 5px;
}

.labelDescription {
  font-size: 10px;
  margin-left: 5px;
}

.label-floating-login {
  margin-left: 5px;
  margin-right: 5px;
}

.button-go-back {
  background-color: white;
  border: 1px solid var(--ion-color-primary);
  border-radius: 10px;
  color: var(--ion-color-primary);
  --background: "white";
  font-size: 17px;
}

/* Same fields and buttons as the access forms (kept last so it wins over the rules above) */
form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* Title / description rows of the forms */
ion-item {
  --padding-start: 0;
  --inner-padding-end: 0;
  --background: transparent;
  --min-height: 0;
}

.titleLbl {
  margin: 0;
  font-size: 21px;
  font-weight: 700;
  text-align: left;
  color: var(--ion-text-color, #000);
}

.descriptionlbl {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  color: var(--ion-color-medium-shade);
}

/* Inputs: outlined and rounded, primary ring when focused */
ion-input,
ion-select {
  --border-radius: 10px;
  --border-color: rgba(var(--ion-color-medium-rgb), 0.4);
  --highlight-color-focused: var(--ion-color-primary);
  --background: var(--ion-background-color, #fff);
  min-height: 56px;
}

/* Primary action */
.button-login {
  height: 50px;
  margin: 6px 0 0;
  --border-radius: 10px;
  --box-shadow: none;
  font-size: 16px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
}

/* Secondary actions (create account, go back) */
.button-account,
.button-go-back {
  height: 48px;
  margin: 8px 0 0;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  --background: transparent;
  --border-radius: 10px;
  --color: var(--ion-color-primary);
  --box-shadow: inset 0 0 0 1px rgba(var(--ion-color-primary-rgb), 0.35);
  font-size: 15px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
}

.label-forgot-password {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.label-forgot-password:hover {
  color: var(--ion-color-primary);
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/theme/_auth.scss","webpack://./src/components/form-components/form-user-change-password/form-user-change-password.component.scss"],"names":[],"mappings":"AAAA;;kGAAA;ACEA;EACE,cAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,YAAA;EACA,eAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;AAEF;;AAGI;EACE,iCAAA;AAAN;AAIE;EACE,iEAAA;EACA,mBAAA;AAFJ;AAII;EACE,6CAAA;EACA,wBAAA;AAFN;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,qBAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;;EAEE,aAAA;EACA,gBAAA;AAJF;;AAOA;EACE,2BAAA;EACA,qCAAA;EACA,kBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;AAJF;;AAOA;EACE,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,qDAAA;AAJF;;AAOA;EACE,0CAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,0CAAA;AAJF;AAME;EACE,YAAA;AAJJ;;AAQA;EACE,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,+BAAA;EACA,0CAAA;EACA,YAAA;EACA,eAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,+BAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,iBAAA;AALF;;AAQA;EACE,uBAAA;EACA,0CAAA;EACA,mBAAA;EACA,+BAAA;EACA,qBAAA;EACA,eAAA;AALF;;AAQA,4FAAA;ADrIE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACiIJ;;AD9HE,0CAAA;AACA;EACE,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;ACiIJ;;AD9HE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;ACiIJ;;AD9HE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;ACiIJ;;AD9HE,4DAAA;AACA;;EAEE,qBAAA;EACA,sDAAA;EACA,mDAAA;EACA,+CAAA;EACA,gBAAA;ACiIJ;;AD9HE,mBAAA;AACA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;ACiIJ;;AD9HE,gDAAA;AACA;;EAEE,YAAA;EACA,eAAA;EACA,oBAAA;EACA,2BAAA;EACA,kCAAA;EACA,yBAAA;EACA,qBAAA;EACA,iCAAA;EACA,sEAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;ACiIJ;;AD9HE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACiIJ;AD/HI;EACE,+BAAA;EACA,0BAAA;ACiIN","sourcesContent":["/* Form styling shared by the profile forms (profile data, change password): outlined rounded\n * inputs, title/description rows, primary and secondary buttons. Use it with\n * @include auth.auth-form; at the END of the component stylesheet, so it wins over older rules. */\n\n@mixin auth-form {\n  form {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n  }\n\n  /* Title / description rows of the forms */\n  ion-item {\n    --padding-start: 0;\n    --inner-padding-end: 0;\n    --background: transparent;\n    --min-height: 0;\n  }\n\n  .titleLbl {\n    margin: 0;\n    font-size: 21px;\n    font-weight: 700;\n    text-align: left;\n    color: var(--ion-text-color, #000);\n  }\n\n  .descriptionlbl {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.5;\n    text-align: left;\n    color: var(--ion-color-medium-shade);\n  }\n\n  /* Inputs: outlined and rounded, primary ring when focused */\n  ion-input,\n  ion-select {\n    --border-radius: 10px;\n    --border-color: rgba(var(--ion-color-medium-rgb), 0.4);\n    --highlight-color-focused: var(--ion-color-primary);\n    --background: var(--ion-background-color, #fff);\n    min-height: 56px;\n  }\n\n  /* Primary action */\n  .button-login {\n    height: 50px;\n    margin: 6px 0 0;\n    --border-radius: 10px;\n    --box-shadow: none;\n    font-size: 16px;\n    font-weight: 600;\n    text-transform: none;\n    letter-spacing: normal;\n  }\n\n  /* Secondary actions (create account, go back) */\n  .button-account,\n  .button-go-back {\n    height: 48px;\n    margin: 8px 0 0;\n    border: 0 !important;\n    border-radius: 0 !important;\n    background: transparent !important;\n    --background: transparent;\n    --border-radius: 10px;\n    --color: var(--ion-color-primary);\n    --box-shadow: inset 0 0 0 1px rgba(var(--ion-color-primary-rgb), 0.35);\n    font-size: 15px;\n    font-weight: 600;\n    text-transform: none;\n    letter-spacing: normal;\n  }\n\n  .label-forgot-password {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n\n    &:hover {\n      color: var(--ion-color-primary);\n      text-decoration: underline;\n    }\n  }\n}\n","@use \"../../../theme/auth\";\n\nion-checkbox {\n  margin-left: 0;\n}\n\nion-button {\n  width: 100%;\n}\n\n.iconTab {\n  height: 15px;\n  font-size: 16px;\n}\n\n.centerCol {\n  display: flex;\n  align-items: center;\n}\n\nion-item {\n  &.item-has-focus {\n    ion-label {\n      color: var(--ion-color-secondary);\n    }\n  }\n\n  ion-input {\n    border-bottom: thin solid rgba(var(--ion-color-medium-rgb), 0.25);\n    --padding-end: 33px;\n\n    &.ion-valid.has-focus {\n      border-bottom-color: var(--ion-color-primary);\n      border-bottom-width: 2px;\n    }\n  }\n}\n\nion-checkbox {\n  margin-right: 15px;\n}\n\n.label-term-of-condition {\n  white-space: pre-wrap;\n}\n\n.item-remember-me {\n  margin-top: 9px;\n}\n\n.item-auto-access {\n  margin-bottom: 9px;\n}\n\n.checkbox-in-list,\n.checkbox-label {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.item-checkbox {\n  --ripple-color: transparent;\n  --background-hover: var(--background);\n  --min-height: 35px;\n}\n\n.button-login {\n  --box-shadow: none;\n  --border-radius: 10px;\n  font-size: 17px;\n}\n\n.button-account {\n  --box-shadow: none;\n  --background: white;\n  color: var(--ion-color-primary);\n  border: 1px solid var(--ion-color-primary) !important;\n}\n\n.divRole {\n  background-color: var(--ion-color-primary);\n  color: white;\n  width: 100%;\n  border-radius: 10px;\n  cursor: hand;\n  cursor: pointer;\n  border: 2px solid var(--ion-color-primary);\n\n  ion-icon {\n    color: white;\n  }\n}\n\n.divRoleNotSelected {\n  background-color: white;\n  border-radius: 10px;\n  width: 100%;\n  color: var(--ion-color-primary);\n  border: 2px solid var(--ion-color-primary);\n  cursor: hand;\n  cursor: pointer;\n}\n\n.gridRole {\n  padding: 15px 15px;\n}\n\nion-icon {\n  color: var(--ion-color-primary);\n}\n\n.roleItem {\n  margin-top: 5px;\n}\n\n.labelRole {\n  margin-left: 5px;\n}\n\n.labelDescription {\n  font-size: 10px;\n  margin-left: 5px;\n}\n\n.label-floating-login {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\n.button-go-back {\n  background-color: white;\n  border: 1px solid var(--ion-color-primary);\n  border-radius: 10px;\n  color: var(--ion-color-primary);\n  --background: \"white\";\n  font-size: 17px;\n}\n\n/* Same fields and buttons as the access forms (kept last so it wins over the rules above) */\n@include auth.auth-form;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
